import { createRouteRef } from '@backstage/core-plugin-api';

export const changeManagementRouteRef = createRouteRef({
  id: 'change-management',
});